import type { FunctionComponent } from "react";
import Highlighter from "react-highlight-words";
import { HIGHLIGHT_PROPS } from "components/company/CompanyTable/CompanyLifecycle/constants";
import useCompanyLifecycleProps from "components/company/CompanyTable/CompanyLifecycle/useCompanyLifecycleProps";

export interface CompanyLifecycleProps {
  lifecycle: string;
}

const CompanyLifecycle: FunctionComponent<CompanyLifecycleProps> = ({
  lifecycle: initialCompanyLifecycle,
}) => {
  const { searchWords, lifecycle } = useCompanyLifecycleProps(
    initialCompanyLifecycle
  );

  return (
    <div className="flex flex-col text-14-22 text-neutral-900">
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords || []}
        textToHighlight={lifecycle || ""}
      />
    </div>
  );
};

export default CompanyLifecycle;
